import { DatePipe } from "@angular/common";
import { Injectable } from "@angular/core";
import { AbstractControl, ValidationErrors } from "@angular/forms";
import { IFilterBrokerRequest } from "../interfaces/filter.interface";
import { FileShared } from "../models/file-shared.model";
import { ISelect } from "./../interfaces/select.interface";

@Injectable({
	providedIn: "root"
})
export class UtilsService {
	constructor() {}

	KeyNumOnly(event: any) {
		if (event.clipboardData !== undefined) {
			return false;
		}
		var charCode = event.which ? event.which : event.keyCode;
		if (charCode > 31 && (charCode < 48 || charCode > 57)) {
			return false;
		}
		return true;
	}

	formatField(campo, Mascara, evento) {
		var boleanoMascara;
		var Digitato = evento.keyCode;
		var exp = /\D/g;
		var campoSoNumeros = campo.value.toString().replace(exp, "");

		var posicaoCampo = 0;
		var NovoValorCampo = "";
		var TamanhoMascara = campoSoNumeros.length;
		var i = 0;

		if (Digitato != 8) {
			for (i = 0; i <= TamanhoMascara; i++) {
				if (NovoValorCampo.length === Mascara.length) {
					campo.value = NovoValorCampo;
					return true;
				}

				boleanoMascara = Mascara.charAt(i) == "-" || Mascara.charAt(i) == "." || Mascara.charAt(i) == "/";
				boleanoMascara =
					boleanoMascara || Mascara.charAt(i) == "(" || Mascara.charAt(i) == ")" || Mascara.charAt(i) == " ";
				if (boleanoMascara) {
					NovoValorCampo += Mascara.charAt(i);
					TamanhoMascara++;
				} else {
					NovoValorCampo += campoSoNumeros.charAt(posicaoCampo);
					posicaoCampo++;
				}
			}
			campo.value = NovoValorCampo;
			return true;
		} else {
			return true;
		}
	}

	dateAddDays(date: string, days: number) {
		const d = new Date(date);
		d.setDate(d.getDate() + days);
		return d;
	}

	convertB64ToFile(b64Data, nameFile, extension) {
		var link = document.createElement("a");
		link.download = nameFile + extension;
		link.href = "data:application/octet-stream;base64," + b64Data;
		link.click();
	}

	formatCNPJCPF(value: string): string {
		if (!!value) {
			const text = value?.replace(/[^0-9]/g, "");
			if (text.length === 11) {
				return text.substr(0, 3) + "." + text.substr(3, 3) + "." + text.substr(6, 3) + "-" + text.substr(9, 2);
			} else if (text.length === 14) {
				return (
					text.substr(0, 2) +
					"." +
					text.substr(2, 3) +
					"." +
					text.substr(5, 3) +
					"/" +
					text.substr(8, 4) +
					"-" +
					text.substr(12, 2)
				);
			}
		}
		return value;
	}

	checkFormField(value: string): boolean {
		return !!value ? true : false;
	}

	checkValueIsBigger(firstValue: number, secondValue: number) {
		if (firstValue > secondValue) {
			return true;
		}
		return false;
	}

	createDefaultDdl(): ISelect[] {
		const dropdownList: { value: string; viewValue: string }[] = [{ value: " ", viewValue: "Selecione" }];
		return dropdownList;
	}

	createDdlStatus(): ISelect[] {
		const dropdownList: { value: string; viewValue: string }[] = [
			{ value: " ", viewValue: "Selecione" },
			{ value: "true", viewValue: "Ativo" },
			{ value: "false", viewValue: "Inativo" }
		];
		return dropdownList;
	}

	returnOnlyNumbersFromCnpjCpf(text: string) {
		return !!text ? text.replace(".", "").replace(".", "").replace("-", "").replace("/", "") : text;
	}

	returnlocalStorageProposta(): any {
		if (!!localStorage.getItem("propostas")) {
			return JSON.parse(localStorage.getItem("propostas"))?.claim?.claims.sort((a, b) => a.order - b.order);
		} else {
			return [];
		}
	}

	setStringToBase64String(text: string) {
		if (!!text) {
			return btoa(text);
		}
		return text;
	}

	getBrokerOrCommercialName(broker: any): IFilterBrokerRequest {
		let razaoSocial = "";
		let cpfOrCnpj = "";

		if (!!broker) {
			if (Array.isArray(broker)) {
				razaoSocial = broker[0]?.viewValue ?? "";
				cpfOrCnpj = broker[0]?.cpfOrCnpj ?? "";
			} else if (typeof broker === "object") {
				razaoSocial = broker?.viewValue ?? "";
				cpfOrCnpj = broker?.cpfOrCnpj ?? "";
			} else {
				razaoSocial = !!broker ? broker : razaoSocial;
			}
		}

		const filterBrokerRequest: IFilterBrokerRequest = {
			razaoSocial: razaoSocial?.toUpperCase(),
			cnpj: cpfOrCnpj?.toUpperCase()
		};

		if (filterBrokerRequest.razaoSocial.startsWith("CORRETORA: ")) {
			filterBrokerRequest.razaoSocial = filterBrokerRequest.razaoSocial.replace("CORRETORA: ", "");
		} 
		if (filterBrokerRequest.razaoSocial.startsWith("CORRETORA:")) {
			filterBrokerRequest.razaoSocial = filterBrokerRequest.razaoSocial.replace("CORRETORA:", "");
		} 
		else if (filterBrokerRequest.razaoSocial.startsWith("COMERCIAL: ")) {
			filterBrokerRequest.razaoSocial = filterBrokerRequest.razaoSocial.replace("COMERCIAL: ", "");
		}

		return filterBrokerRequest;
	}

	validateBiddingNumber(control: AbstractControl): ValidationErrors | null {
		const biddingNumber = control.value;

		if (!!biddingNumber) {
			if (
				/(?=.*?[a-z])/.test(biddingNumber) === true ||
				/(?=.*?[A-Z])/.test(biddingNumber) === true ||
				/(?=.*?[0-9])/.test(biddingNumber) === true
			) {
				return null;
			}
			return { biddingNumberValid: true };
		}
		return null;
	}

	returnStringWithoutAccent(text: string): string {
		if (!!text) {
			return text.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
		}
		return text;
	}

	validateInsuredObject(control: AbstractControl): ValidationErrors | null {
		if (!control.value) {
			return { objectInsuredInvalid: true };
		}
		return null;
	}

	convertStringToBinaryString(text: string) {
		var result = "";
		if (!!text) {
			for (var i = 0; i < text.length; i++) {
				result += text[i].charCodeAt(0).toString(2) + " ";
			}
		} else {
			result = text;
		}
		return result;
	}

	convertToPDF(fileShared: FileShared) {
		var link = document.createElement("a");
		link.innerHTML = "Download PDF file";
		link.download = fileShared.fileName + fileShared.fileExtension;
		link.href = "data:application/octet-stream;base64," + fileShared.dataBase64;
		link.click();
	}

	convertToPDFDefault(b64Data) {
		var link = document.createElement("a");
		link.innerHTML = "Download PDF file";
		link.download = "Impressao.pdf";
		link.href = "data:application/octet-stream;base64," + b64Data;
		link.click();
	}

	convertStringToDate(stringDate: string): Date {
		return new Date(`${stringDate} 00:00:00`);
	}

	convertDateToString(date: Date, datePipe: DatePipe): string {
		return datePipe.transform(date, "dd/MM/yyyy");
	}

	retornarListaOrdenada(lista: ISelect[]) {
		return !!lista ? lista.sort((x, y) => x.order - y.order) : lista;
	}

	base642String(base64String: string) {
		const decodedBytes = new Uint8Array(
			atob(base64String)
				.split("")
				.map(c => c.charCodeAt(0))
		);

		const decodedStr = new TextDecoder().decode(decodedBytes);
		return decodedStr;
	}

	getDateFormat(data: any, datePipe: DatePipe) {
		try {
			if (data) {
				return datePipe.transform(data, "dd/MM/yyyy");
			} else {
				return "Sem data definida.";
			}
			1;
		} catch {
			return "Sem data definida.";
		}
	}

	formatedDate(validityPeriod: number): any {
		var d = new Date();
		var year = d.getFullYear();
		var month = d.getMonth();
		var day = d.getDate();

		if (validityPeriod === 1) {
			return (
				year +
				3 +
				"-" +
				((month + 1).toString().length > 1 ? month + 1 : "0" + (month + 1)) +
				"-" +
				(day.toString().length > 1 ? day : "0" + day)
			);
		} else if (validityPeriod === 2) {
			return (
				year +
				4 +
				"-" +
				((month + 1).toString().length > 1 ? month + 1 : "0" + (month + 1)) +
				"-" +
				(day.toString().length > 1 ? day : "0" + day)
			);
		} else if (validityPeriod == 3) {
			return (
				year +
				5 +
				"-" +
				((month + 1).toString().length > 1 ? month + 1 : "0" + (month + 1)) +
				"-" +
				(day.toString().length > 1 ? day : "0" + day)
			);
		}

		return null;
	}

	getYearDeadLine(complaninerDeadLineValidity: number): number {
		if (complaninerDeadLineValidity === 1) {
			return 3;
		} else if (complaninerDeadLineValidity === 2) {
			return 4;
		} else if (complaninerDeadLineValidity == 3) {
			return 5;
		}

		return 0;
	}

	getFormatProcessNumber(number): string {
		let formatedNumber = "-";

		if (number) {
			formatedNumber = `${number.substring(0, 7)}-${number.substring(7, 9)}.${number.substring(9, 13)}.${number.substring(13, 14)}.${number.substring(14, 16)}.${number.substring(16, 20)}`;
		}

		return formatedNumber;
	}

	inputIsURL(text: string) {
		try {
			const list: string[] = ["file:", "h:", "ht:", "htt:", "http:", "https:"];
			if (text.startsWith("://") || text.startsWith(":/") || text.startsWith("/") || text.startsWith("//")) {
				return true;
			} else {
				const newUrl = new URL(text);
				return list.some(x => x.toUpperCase() === newUrl.protocol.toUpperCase());
			}
		} catch (err) {
			return false;
		}
	}
}
